import React, { forwardRef } from "react";
import { Grid2 as Grid, Grid2Props } from "@mui/material";

export const MuiGrid = forwardRef<HTMLDivElement, Grid2Props>((props, ref) => {
  return <Grid data-testid={props.id} {...props} ref={ref} />;
});